var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabaseSkill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 20c0-5 8-9 18-9s18 4 18 9-8 9-18 9-18-4-18-9Z",
    stroke: "#FFF",
    strokeWidth: 2.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20v24c0 5 8 9 18 9s18-4 18-9V20",
    stroke: "#FFF",
    strokeWidth: 2.8,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 32c0 5 8 9 18 9s18-4 18-9",
    stroke: "#FFF",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 44c0 5 8 9 18 9s18-4 18-9",
    stroke: "#FFF",
    strokeWidth: 2.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseSkill);
export default __webpack_public_path__ + "static/media/database-skill.aad43ecdaac7eedc7b45ae34f2c3f206.svg";
export { ForwardRef as ReactComponent };